import { useAuth } from "react-oidc-context";

const useVendorAuthContext = () => {
	const instance = useAuth();
	return {
		instance,
	};
};

export default useVendorAuthContext;
